module.exports = __webpack_public_path__ + "static/media/gensuite-india.756dd45c.png";